/**
 * @generated SignedSource<<79f3f3ea54b611637db68e97aeef7605>>
 * @relayHash a441a842c548552321409dbab7a428ad
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/TransactionUpdateShipmentMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TransactionUpdateShipmentInput = {
  clientMutationId?: string | null;
  shippingAddressId?: string | null;
  transactionId: string;
};
export type TransactionUpdateShipmentMutation$variables = {
  input: TransactionUpdateShipmentInput;
};
export type TransactionUpdateShipmentMutation$data = {
  readonly transactionUpdateShipment: {
    readonly transaction: {
      readonly shipment: {
        readonly shippingAddress: {
          readonly id: string;
        } | null;
      } | null;
    };
  } | null;
};
export type TransactionUpdateShipmentMutation = {
  response: TransactionUpdateShipmentMutation$data;
  variables: TransactionUpdateShipmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "shippingAddress",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionUpdateShipmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "transactionUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionUpdateShipmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "transactionUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Transaction",
            "kind": "LinkedField",
            "name": "transaction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/TransactionUpdateShipmentMutation",
    "metadata": {},
    "name": "TransactionUpdateShipmentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8996c9e637f97facd35ea92313760c46";

export default node;
